// extracted by mini-css-extract-plugin
export var formContainer = "_c2-0";
export var message = "_c2-1";